<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>OVERVIEW</div>
				<h2 waHeading="l" waText>What JWebMP Can Do</h2>
				<p waBody="m" waColorText="quiet" waText>A comprehensive look at every layer of the framework.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>JWebMP is a full-stack Java framework for building reactive web applications. It produces both the backend &#40;Vert.x HTTP server, Guice DI, AJAX pipeline&#41; and the frontend &#40;Angular 21 SPA&#41; from a single Java codebase. Explore each capability in detail via the menu tree.</p>
			</div>
		</div>
	</div>
</div>